import AccountPage from "./AccountPage";

export default AccountPage;

export * from "./AccountPage";
